import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import {
  createCustomerDependentPagedAutoCompleteMetaData,
  createDomainPagedAutoCompleteMetaData,
} from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { cloneDeep } from "lodash";
import {
  IAddDeliveryNote,
  IUpdateDeliveryNote,
} from "mobx-stores/_models/delivery-note/delivery-note";

import { date, number, string } from "yup";
export const getAddDeliveryNoteFormSchema = (
  form: IForm,
): ObjectSchemaType<IAddDeliveryNote> => {
  const resolveCustomerId = () => form?.getControl("customerId").value ?? null;

  return {
    date: {
      gridSize: 6,
      label: "Ngày",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },

    purchaseOrderId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Đơn đặt hàng",
      validattionYupSchema: string().nullable(),
      metaData: createDomainPagedAutoCompleteMetaData("order"),
    },
    customerId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Tên giao dịch",
      validattionYupSchema: string().required(),
      metaData: createDomainPagedAutoCompleteMetaData("customer"),
    },
    man: {
      gridSize: 6,
      label: "Người giao",
      type: InputType.text,
      validattionYupSchema: string().max(50),
    },
    licensePalate: {
      gridSize: 6,
      label: "Biển số",
      type: InputType.text,
      validattionYupSchema: string().max(20),
    },
    deliveryAddressId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Địa chỉ giao hàng",
      validattionYupSchema: string().required(),
      metaData: {
        searchOptionItemsAsync: async () => {
          const customerId = resolveCustomerId();
          if (!customerId) return [];
          return await customerBusiness.getDeliveryAddressByCustomerAsOptionItems(
            customerId,
          );
        },
      },
    },
    note: {
      gridSize: 12,
      label: "Ghi chú",
      type: InputType.textArea,
      validattionYupSchema: string().max(512),
    },

    items: {
      label: "Chi tiết phiếu giao hàng",
      type: InputType.array,
      arraySchema: {
        productId: {
          label: "Mặt hàng",
          gridSize: 3,
          type: InputType.autoComplete,
          validattionYupSchema: string().required(),
          metaData: createCustomerDependentPagedAutoCompleteMetaData(
            "product",
            resolveCustomerId,
          ),
          defaultValue: "",
        },
        amount: {
          label: "Số lượng (pcs)",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        weight: {
          label: "Trọng lượng (kg)",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        mh: {
          label: "M/H",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        package: {
          label: "Kiện",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        note: {
          label: "Ghi chú",
          gridSize: 5,
          type: InputType.text,
          validattionYupSchema: string().max(512),
          defaultValue: "",
        },
      },
    },
  };
};

export const getEditDeliveryNoteFormSchema = (
  form: IForm,
): ObjectSchemaType<IUpdateDeliveryNote> => {
  const schema = getAddDeliveryNoteFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdateDeliveryNote> = cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };
  updateSchema.items.arraySchema.id = {
    type: InputType.none,
  };
  return updateSchema;
};
